
import React from 'react';

/**
 * Tabs Component
 * A reusable tab system for navigation and sub-tabs across the application.
 * Features a clean, premium design with animated underlines.
 * 
 * @param {Array} tabs - Array of tab objects { id, label, icon }
 * @param {string} activeTab - The ID of the currently active tab
 * @param {function} onChange - Callback function when a tab is clicked
 * @param {string} variant - 'main' for top-level navigation, 'sub' for section sub-tabs
 */
export const Tabs = ({ 
  tabs = [], 
  activeTab, 
  onChange, 
  variant = 'sub',
  className = "" 
}) => {
  return (
    <div className={`flex items-center gap-8 border-b border-slate-100 overflow-x-auto no-scrollbar shrink-0 px-1 ${className}`}>
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id;
        const Icon = tab.icon;

        return (
          <button
            key={tab.id}
            onClick={() => onChange(tab.id)}
            className={`
              pb-4 px-2 transition-all relative flex items-center gap-2 group whitespace-nowrap
              text-[14px] font-medium
              ${isActive ? 'text-slate-800' : 'text-slate-400 hover:text-slate-500'}
            `}
          >
            {Icon && (
              <Icon 
                size={18} 
                className={`transition-colors ${isActive ? 'text-slate-800' : 'text-slate-300 group-hover:text-slate-400'}`} 
              />
            )}
            <span>{tab.label}</span>
            
            {isActive && (
              <div className={`
                absolute bottom-0 left-0 right-0 bg-slate-800 rounded-full h-[2px]
                animate-in slide-in-from-left-2 duration-300
              `} />
            )}
          </button>
        );
      })}
    </div>
  );
};




